/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { integrationEventsControllerFindAll } from '../fn/integration-events/integration-events-controller-find-all';
import { IntegrationEventsControllerFindAll$Params } from '../fn/integration-events/integration-events-controller-find-all';
import { IntegrationEventsPaginatedResponse } from '../models/integration-events-paginated-response';

@Injectable({ providedIn: 'root' })
export class IntegrationEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `integrationEventsControllerFindAll()` */
  static readonly IntegrationEventsControllerFindAllPath = '/integration-events';

  /**
   * Get integration events.
   *
   * Retrieve integration events with cursor-based pagination.
   *       
   *       **Pagination Strategy:**
   *       - Use the `afterId` parameter to fetch events after a specific event
   *       - Events are ordered by `occurredAt ASC`, then by `id` for deterministic ordering
   *       - The response includes `hasMore` to indicate if more events exist
   *       - Use the `lastId` from the response as `afterId` for the next page
   *       
   *       **Usage Pattern for Consumers:**
   *       1. Store the last successfully processed event ID
   *       2. On each poll, use that ID as `afterId`
   *       3. Process events in order
   *       4. Update the stored ID after successful processing
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationEventsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationEventsControllerFindAll$Response(params: IntegrationEventsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationEventsPaginatedResponse>> {
    return integrationEventsControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Get integration events.
   *
   * Retrieve integration events with cursor-based pagination.
   *       
   *       **Pagination Strategy:**
   *       - Use the `afterId` parameter to fetch events after a specific event
   *       - Events are ordered by `occurredAt ASC`, then by `id` for deterministic ordering
   *       - The response includes `hasMore` to indicate if more events exist
   *       - Use the `lastId` from the response as `afterId` for the next page
   *       
   *       **Usage Pattern for Consumers:**
   *       1. Store the last successfully processed event ID
   *       2. On each poll, use that ID as `afterId`
   *       3. Process events in order
   *       4. Update the stored ID after successful processing
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationEventsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationEventsControllerFindAll(params: IntegrationEventsControllerFindAll$Params, context?: HttpContext): Observable<IntegrationEventsPaginatedResponse> {
    return this.integrationEventsControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationEventsPaginatedResponse>): IntegrationEventsPaginatedResponse => r.body)
    );
  }

}
